const formatBuildTimestamp = (isoDate) =>
  new Date(isoDate).toISOString().replace(/[-:]/g, '').split('.')[0];

const buildTimeSource = process.env.REACT_APP_BUILD_TIME || new Date().toISOString();
const gitSha = process.env.REACT_APP_GIT_SHA;
const commit = gitSha ? gitSha.slice(0, 12) : null;

export const VERSION = {
  MAJOR: 1,
  MINOR: 2,
  BUILD: formatBuildTimestamp(buildTimeSource),
  COMMIT: commit,

  toString() {
    const commitSuffix = this.COMMIT ? `-${this.COMMIT}` : '';
    return `v${this.MAJOR}.${this.MINOR}.${this.BUILD}${commitSuffix}`;
  },
};
